import './southwesterncc/style';
import FormStructure from './southwesterncc/form_structure';

export default FormStructure;